const GET_AFFILIATE_BY_ID_STARTED = 'GET_AFFILIATE_BY_ID_STARTED';
const GET_AFFILIATE_BY_ID_STARTED_SUCCESS = 'GET_AFFILIATE_BY_ID_STARTED_SUCCESS';
const GET_AFFILIATE_BY_ID_STARTED_FAIL = 'GET_AFFILIATE_BY_ID_STARTED_FAIL';
const GET_AFFILIATE_BY_ID_COMMISSION_PROFILES_STARTED = 'GET_AFFILIATE_BY_ID_COMMISSION_PROFILES_STARTED';
const GET_AFFILIATE_BY_ID_COMMISSION_PROFILES_SUCCESS = 'GET_AFFILIATE_BY_ID_COMMISSION_PROFILES_SUCCESS';
const GET_AFFILIATE_BY_ID_COMMISSION_PROFILES_FAIL = 'GET_AFFILIATE_BY_ID_COMMISSION_PROFILES_FAIL';
const DELETE_AFFILIATE_BY_ID_COMMISSION_PROFILES_STARTED = 'DELETE_AFFILIATE_BY_ID_COMMISSION_PROFILES_STARTED';
const DELETE_AFFILIATE_BY_ID_COMMISSION_PROFILES_SUCCESS = 'DELETE_AFFILIATE_BY_ID_COMMISSION_PROFILES_SUCCESS';
const DELETE_AFFILIATE_BY_ID_COMMISSION_PROFILES_FAIL = 'DELETE_AFFILIATE_BY_ID_COMMISSION_PROFILES_FAIL';

const getAffiliateByID = (id, history) => {
	return {
		type: GET_AFFILIATE_BY_ID_STARTED,
		id,
		history,
	};
};
const getAffiliateByIDSuccess = (response = []) => {
	return {
		type: GET_AFFILIATE_BY_ID_STARTED_SUCCESS,
		response,
	};
};
const getAffiliateByIDFail = () => {
	return {
		type: GET_AFFILIATE_BY_ID_STARTED_FAIL,
	};
};

const getAffiliateByIDCommissionProfile = (id) => {
	return {
		type: GET_AFFILIATE_BY_ID_COMMISSION_PROFILES_STARTED,
		id,
	};
};
const getAffiliateByIDCommissionProfileSuccess = (response = []) => {
	return {
		type: GET_AFFILIATE_BY_ID_COMMISSION_PROFILES_SUCCESS,
		response,
	};
};
const getAffiliateByIDCommissionProfileFail = () => {
	return {
		type: GET_AFFILIATE_BY_ID_COMMISSION_PROFILES_FAIL,
	};
};

const deleteAffiliateByIDCommissionProfile = (request, history) => {
	return {
		type: DELETE_AFFILIATE_BY_ID_COMMISSION_PROFILES_STARTED,
		request,
		history,
	};
};
const deleteAffiliateByIDCommissionProfileSuccess = () => {
	return {
		type: DELETE_AFFILIATE_BY_ID_COMMISSION_PROFILES_SUCCESS,
	};
};
const deleteAffiliateByIDCommissionProfileFail = () => {
	return {
		type: DELETE_AFFILIATE_BY_ID_COMMISSION_PROFILES_FAIL,
	};
};

export default {
	types: {
		GET_AFFILIATE_BY_ID_STARTED,
		GET_AFFILIATE_BY_ID_STARTED_SUCCESS,
		GET_AFFILIATE_BY_ID_STARTED_FAIL,
		GET_AFFILIATE_BY_ID_COMMISSION_PROFILES_STARTED,
		GET_AFFILIATE_BY_ID_COMMISSION_PROFILES_SUCCESS,
		GET_AFFILIATE_BY_ID_COMMISSION_PROFILES_FAIL,
		DELETE_AFFILIATE_BY_ID_COMMISSION_PROFILES_STARTED,
		DELETE_AFFILIATE_BY_ID_COMMISSION_PROFILES_SUCCESS,
		DELETE_AFFILIATE_BY_ID_COMMISSION_PROFILES_FAIL,
	},
	creators: {
		getAffiliateByID,
		getAffiliateByIDSuccess,
		getAffiliateByIDFail,
		getAffiliateByIDCommissionProfile,
		getAffiliateByIDCommissionProfileSuccess,
		getAffiliateByIDCommissionProfileFail,
		deleteAffiliateByIDCommissionProfile,
		deleteAffiliateByIDCommissionProfileSuccess,
		deleteAffiliateByIDCommissionProfileFail,
	},
};
